export const canUseHtmlDialogElement =
  typeof document.createElement("dialog")?.showModal === "function";
